import * as yapFlowTypes from '../../consts/yap/yapFlowTypes';
import {
    setYapAutoCleaningInProgress,
    setYapFirmwareInProgress,
    setYapSyncInProgress,
    setYapUpdateSettingsInProgress,
} from '../../state/ducks/yapEncrypted';
import {
    makeSelectIsDeviceSyncInProgress,
    makeSelectIsYapAutoCleaningInProgress,
    makeSelectIsYapFirmwareInProgress,
    makeSelectIsYapUpdateSettingsInProgress,
    makeSelectSyncLastRequestId,
    makeSelectYapLastRequestId,
} from '../../state/selectors/yapEncrypted';
import {dispatch, getState} from '../../state/store';
import * as dataCollectionService from '../uam/dataCollectionService';
import yapCheckStatusService from './yapCheckStatusService';

let instances = [];

const createFlowTimeout = (params) => {
    const {type, timeoutInSec, isHolder, data = null} = params;
    const curInstance = getFlowInstance(type, isHolder);

    clearTimeout(curInstance);

    const instance = setTimeout(async () => {
        const isValid = isFlowValid(type, isHolder, data);

        if (!isValid) return;

        const isFlowFinished = await yapCheckStatusService.checkYapRequestStatus(isHolder, true);

        if (isFlowFinished) return;

        const isRequestValid = isRequestIdValid(type, isHolder, data);

        if (!isRequestValid) return;

        createFlowTimeout(params);
    }, timeoutInSec * 1000);

    addFlowInstance(instance, type, isHolder);
};

const isRequestIdValid = (type, isHolder, data) => {
    const state = getState();
    const requestId =
        type === yapFlowTypes.SYNCHRONIZE
            ? makeSelectSyncLastRequestId(isHolder)(state)
            : makeSelectYapLastRequestId(isHolder)(state);

    if (requestId) return true;

    switch (type) {
        case yapFlowTypes.UPDATE_SETTINGS:
            dispatch(setYapUpdateSettingsInProgress(false, isHolder));
            return false;
        case yapFlowTypes.AUTO_CLEAN:
            dispatch(setYapAutoCleaningInProgress(false));
            return false;
        case yapFlowTypes.UPDATE_FIRMWARE:
            dispatch(setYapFirmwareInProgress(false));
            return false;
        case yapFlowTypes.SYNCHRONIZE:
            dispatch(setYapSyncInProgress(false, isHolder));
            return false;
        case yapFlowTypes.DATA_COLLECTION:
            dataCollectionService.setDataCollectionFlowInProgress(false, data);
            return false;
        default:
            break;
    }

    return true;
};

const isFlowValid = (type, isHolder, data) => {
    const state = getState();

    switch (type) {
        case yapFlowTypes.UPDATE_SETTINGS:
            const isYapUpdateSettingsInProgress = makeSelectIsYapUpdateSettingsInProgress(isHolder)(state);

            if (!isYapUpdateSettingsInProgress) return false;

            break;
        case yapFlowTypes.AUTO_CLEAN:
            const isYapAutoCleaningInProgress = makeSelectIsYapAutoCleaningInProgress()(state);

            if (!isYapAutoCleaningInProgress) return false;

            break;
        case yapFlowTypes.UPDATE_FIRMWARE:
            const isYapFirmwareInProgress = makeSelectIsYapFirmwareInProgress()(state);

            if (!isYapFirmwareInProgress) return false;

            break;
        case yapFlowTypes.SYNCHRONIZE:
            const isSyncInProgress = makeSelectIsDeviceSyncInProgress(isHolder)(state);

            if (!isSyncInProgress) return false;

            break;
        case yapFlowTypes.DATA_COLLECTION:
            const isDataCollectionInProgress = dataCollectionService.isDataCollectionInProgress(data);

            if (!isDataCollectionInProgress) return false;

            break;
        default:
            break;
    }

    return true;
};

const clearFlowTimeout = (type, isHolder) => {
    const curInstance = getFlowInstance(type, isHolder);

    clearTimeout(curInstance);
    addFlowInstance(undefined, type, isHolder);
};

const getFlowInstance = (type, isHolder) => {
    return instances.find((instance) => instance.type === type && instance.isHolder === isHolder)?.instance;
};

const addFlowInstance = (instance, type, isHolder) => {
    instances = instances.filter((instance) => instance.type !== type && instance.isHolder !== isHolder);
    instances.push({type, isHolder, instance});
};

const clearAllFlowsTimeout = () => {
    instances.forEach((x) => clearTimeout(x.instance));
};

export default {
    clearAllFlowsTimeout,
    clearFlowTimeout,
    createFlowTimeout,
};
